import { Typography, Box, Grid, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import React from "react";

import useProgressPhotos from "../../../../hooks/useProgressPhotos";

import MightyDataGrid from "../../../../components/organisms/MightyDataGrid";
import QuestionEditDialog from "./QuestionEditDialog";
import { QuestionType } from "../../../../data/GlobalData";
import ReorderDialog from "./ReorderDialog";
import useEvents from "../../../../hooks/useEvents";

const EditProgressPhotos = () => {
  const {
    progressPhotos,
    savePhotoTypeConfig,
    deletePhotoType,
    addPhotoType,
  } = useProgressPhotos();

  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [questionReorderDialogOpen, setQuestionReorderDialogOpen] =
    React.useState(false);
  const events = useEvents();

  const selectedQuestion = React.useRef();

  const onEdit = (item) => {
    selectedQuestion.current = item;
    setDialogOpen(true);
    const editQuestionEvent = {
      buttonName: "Edit Progress Photo",
      pageName: "Admin",
      tabName: "Progress Photos ",
    };
    events.logButtonClick(editQuestionEvent);
  };

  const onDelete = (item) => {
    deletePhotoType(item.id);
    const deleteQuestionEvent = {
      buttonName: "Delete Progress Photo",
      pageName: "Admin",
      tabName: "Progress Photos ",
    };
    events.logButtonClick(deleteQuestionEvent);
  };

  const titleStrings = React.useMemo(() => {
    const tab = "Progress Photos";
    const button = "Add Position";
    const title = "Progress Photo Positions";
    const description =
      "Progress photo positions determine what angles you want the client to take pictures of when they report. Examples: Front, Side, Back, etc.";
    const editTitle = "Edit Position";
    const reorderTitle = "Reorder Positions";
    return { tab, button, title, description, editTitle, reorderTitle };
  });

  const columns = React.useMemo(() => {
    return [
      {
        field: "name",
        headerName: "Name",
        headerAlign: "left",
        align: "left",
        flex: 1,
        type: "string",
        hideable: false,
        sortable: false,
        filterable: false,
      },
    ];
  }, []);

  return (
    <Box style={{ marginBottom: 54 }}>
      <Grid container style={{ marginTop: 4 }}>
        <Grid item xs={7}>
          <Typography
            style={{ fontSize: 20, fontWeight: "500", marginBottom: 12 }}
          >
            Progress Photo Positions
          </Typography>
          <Typography
            style={{ fontSize: 16, fontWeight: "normal", marginBottom: 12 }}
          >
            Progress photo positions determine what angles you want the client
            to take pictures of when they report. Examples: Front, Side, Back,
            etc.
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Stack direction={"row"} spacing={3} justifyContent={"flex-end"}>
            <Box display="flex" flexDirection="row" justifyContent={"flex-end"}>
              <StandardButton
                style={{ marginTop: 12 }}
                variant="primary"
                onClick={() => {
                  selectedQuestion.current = null;
                  setQuestionReorderDialogOpen(true);
                  const reorderQuestionEvent = {
                    buttonName: "Reorder Progress Photos",
                    pageName: "Admin",
                    tabName: "Progress Photos ",
                  };
                  events.logButtonClick(reorderQuestionEvent);
                }}
              >
                Reorder Positions
              </StandardButton>
            </Box>
            <Box display="flex" flexDirection="row" justifyContent={"flex-end"}>
              <StandardButton
                style={{ marginTop: 12 }}
                variant="primary"
                onClick={() => {
                  selectedQuestion.current = null;
                  setDialogOpen(true);
                  const addQuestionEvent = {
                    buttonName: "Add Progress Photo",
                    pageName: "Admin",
                    tabName: "Progress Photos ",
                  };
                  events.logButtonClick(addQuestionEvent);
                }}
              >
                {titleStrings.button}
              </StandardButton>
            </Box>
          </Stack>
        </Grid>
      </Grid>
      <Box style={{ margin: 12 }}>
        <MightyDataGrid
          entityName="progressPhotos"
          columns={columns}
          rows={progressPhotos || []}
          showActions={true}
          actionConfig={{
            onEdit: onEdit,
            onDelete: onDelete,
            entityName: "Progress Photo Position",
            pageName: "Admin",
            tabName: "Progress Photos",
            customDeleteMessage:
              "This cannot be undone. The question will be removed everywhere it is being used.",
          }}
        />
      </Box>

      {/* Dialogs - Always rendered regardless of data state */}
      <QuestionEditDialog
        open={dialogOpen}
        questionType={QuestionType.progress}
        titleStrings={titleStrings}
        question={selectedQuestion.current}
        onDialogClosed={async (data, question) => {
          if (!data && !question) {
            setDialogOpen(false);
            return;
          }
          setDialogOpen(false);

          if (data && question) {
            question.name = data.name;

            savePhotoTypeConfig(progressPhotos);
          } else {
            addPhotoType(data.name);
          }
        }}
      />
      <ReorderDialog
        open={questionReorderDialogOpen}
        reorderTitle={titleStrings.reorderTitle}
        list={progressPhotos}
        onDialogClosed={async (data) => {
          if (!data) {
            setQuestionReorderDialogOpen(false);
            return;
          }
          setQuestionReorderDialogOpen(false);
          if (data) {
            savePhotoTypeConfig(data);
          }
        }}
      />
    </Box>
  );
};
export default EditProgressPhotos;
